function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "solid"
}, /*#__PURE__*/React.createElement("path", {
  d: "M285.81,77.336a8,8,0,0,0,11.921-10.672,55.992,55.992,0,0,0-83.166-.335A8,8,0,0,0,226.4,77.1a39.992,39.992,0,0,1,59.409.241Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.723,55.57a71.988,71.988,0,0,1,108.586,2.345A8,8,0,0,0,323.6,47.666,87.989,87.989,0,0,0,190.887,44.8,8,8,0,0,0,202.723,55.57Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256,80a24.047,24.047,0,0,0-17.744,7.866,8,8,0,0,0,11.836,10.767,7.968,7.968,0,0,1,12.054.251,8,8,0,1,0,12.286-10.25A23.946,23.946,0,0,0,256,80Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 376,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 224,
  r: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M272,368h-9.376a23.944,23.944,0,0,1,0,16H272a8,8,0,0,0,0-16Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.205,296c4.181-83.971,73.808-151,158.8-151s154.618,67.03,158.8,151l17.007,0a175.2,175.2,0,0,0-40.151-104H416a8,8,0,0,0,0-16H395.313l18.344-18.343a8,8,0,0,0-11.314-11.314L384,164.687V144a8,8,0,0,0-16,0v24.346a175.628,175.628,0,0,0-224,0V144a8,8,0,0,0-16,0v20.687l-18.343-18.344a8,8,0,0,0-11.314,11.314L116.687,176H96a8,8,0,0,0,0,16h24.341A175.2,175.2,0,0,0,80.19,296Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M414.8,312c-4.182,83.97-73.809,151-158.8,151s-154.617-67.029-158.8-151L80.19,312c4.2,93.348,81.445,168,175.81,168s171.613-74.653,175.81-168Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256,161c-78.851,0-143,64.15-143,143s64.149,143,143,143,143-64.149,143-143S334.854,161,256,161Zm0,31a32,32,0,1,1-32,32A32.036,32.036,0,0,1,256,192Zm8,88a8,8,0,1,1-8-8A8,8,0,0,1,264,280Zm-40-8a8,8,0,1,1-8,8A8,8,0,0,1,224,272Zm48,128H240a24,24,0,0,1,0-48h32a24,24,0,0,1,0,48Zm16-112a8,8,0,1,1,8-8A8,8,0,0,1,288,288Z"
}));

function Svg77(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg77);
export default __webpack_public_path__ + "static/media/7_7.58ca77d1.svg";
export { ForwardRef as ReactComponent };